// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingView_wrapper__3S39s"};